export interface Archivo107 {
  etiqueta: string;
  ruta: string;
}

export interface Seccion107 {
  id: string;
  nombre: string;
  descripcion: string;
  icono: string;
  hashClave: string;
  archivos: Archivo107[];
}

// Las claves NO se guardan en texto plano, solo su hash SHA-256.
// La clave global (organizadores) abre todas las secciones.
export const HASH_CLAVE_GLOBAL = "691313c11c4498461d7db3379fba08edd8966bce081a32e1666d682ce606bf24";

export const SECCIONES_107: Seccion107[] = [
  {
    id: "standing",
    nombre: "Standing",
    descripcion: "Tabla de posiciones por división",
    icono: "fas fa-list-ol",
    hashClave: "0f8834a9acbca11b043adfef1b78eec769089a7e8a4bd89d14910e243ad62c68",
    archivos: [
      { etiqueta: "Iniciación", ruta: "./assets/temporada107/standing/iniciacion.pdf" },
      { etiqueta: "Kinder", ruta: "./assets/temporada107/standing/kinder.pdf" },
      { etiqueta: "Infantil menor", ruta: "./assets/temporada107/standing/infantil-menor.pdf" },
      { etiqueta: "Infantil mayor", ruta: "./assets/temporada107/standing/infantil-mayor.pdf" },
      { etiqueta: "Juvenil menor", ruta: "./assets/temporada107/standing/juvenil-menor.pdf" },
      { etiqueta: "Juvenil mayor", ruta: "./assets/temporada107/standing/juvenil-mayor.pdf" }
    ]
  },
  {
    id: "resultados",
    nombre: "Resultados",
    descripcion: "Resultados por jornada de cada división",
    icono: "fas fa-clipboard-list",
    hashClave: "4553cbdde2ba7083a5c07e86c4e1fb224b5c15db58527f9c51ada2edfebe78ae",
    archivos: [
      { etiqueta: "Iniciación", ruta: "./assets/temporada107/resultados/iniciacion.pdf" },
      { etiqueta: "Kinder", ruta: "./assets/temporada107/resultados/kinder.pdf" },
      { etiqueta: "Infantil menor", ruta: "./assets/temporada107/resultados/infantil-menor.pdf" },
      { etiqueta: "Infantil mayor", ruta: "./assets/temporada107/resultados/infantil-mayor.pdf" },
      { etiqueta: "Juvenil menor", ruta: "./assets/temporada107/resultados/juvenil-menor.pdf" },
      { etiqueta: "Juvenil mayor", ruta: "./assets/temporada107/resultados/juvenil-mayor.pdf" }
    ]
  },
  {
    id: "bateo-pitcheo",
    nombre: "Bateo y Pitcheo",
    descripcion: "Estadísticas de bateo y pitcheo por categoría",
    icono: "fas fa-baseball-ball",
    hashClave: "0044708c36bd1b5c385f288c6e85d2ebc69ff48e13420f23768e41c32495189f",
    archivos: [
      { etiqueta: "Kinder", ruta: "./assets/temporada107/bateo-pitcheo/kinder.pdf" },
      { etiqueta: "9-10 años", ruta: "./assets/temporada107/bateo-pitcheo/9-10.pdf" },
      { etiqueta: "11-12 años", ruta: "./assets/temporada107/bateo-pitcheo/11-12.pdf" },
      { etiqueta: "13-14 años", ruta: "./assets/temporada107/bateo-pitcheo/13-14.pdf" },
      { etiqueta: "15-17 años", ruta: "./assets/temporada107/bateo-pitcheo/15-17.pdf" }
    ]
  },
  {
    id: "campeones",
    nombre: "Campeones",
    descripcion: "Campeones individuales por categoría",
    icono: "fas fa-trophy",
    hashClave: "de863b80a72f3e4c2ea0bb3d44da3603805ba9a0c2f68858e065c12676fdbd19",
    archivos: [
      { etiqueta: "Kinder", ruta: "./assets/temporada107/campeones/kinder.pdf" },
      { etiqueta: "9-10 años", ruta: "./assets/temporada107/campeones/9-10.pdf" },
      { etiqueta: "11-12 años", ruta: "./assets/temporada107/campeones/11-12.pdf" },
      { etiqueta: "13-14 años", ruta: "./assets/temporada107/campeones/13-14.pdf" },
      { etiqueta: "15-17 años", ruta: "./assets/temporada107/campeones/15-17.pdf" }
    ]
  }
];
